var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNearbyError = function SvgIconNearbyError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m8.003 5.048 2.947 2.947-2.947 2.946-2.946-2.946zm0 7.747-4.8-4.8 4.8-4.8 4 4v-2.42L8.95 1.72a1.336 1.336 0 0 0-1.887 0l-5.34 5.334c-.52.52-.52 1.366 0 1.886l5.34 5.334c.52.52 1.367.52 1.887 0l3.053-3.06v-2.42zm5.334.54h1.333v1.333h-1.333zm1.333-6.667h-1.333v5.333h1.333z"
  })));
};
export default SvgIconNearbyError;